import { useContext } from 'react'
import { I18nContext } from './context'

/**
 * Access the active locale, `setLocale`, and the `t()` translate function.
 * Must be called inside <I18nProvider>.
 */
export function useI18n() {
  const context = useContext(I18nContext)
  if (!context) {
    throw new Error('useI18n must be used within <I18nProvider>')
  }
  return context
}
